module.exports = __webpack_public_path__ + "img/icon_nav_gift_hover.c27c320d.svg";